import styled from "styled-components/macro";
import {device} from "../../styles";

export const Label = styled.label`
    font-style: normal;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
`;

export const Input = styled.input`
    position: absolute;
    left: -9999px;

    & ~ ${Label} {
        position: relative;
        line-height: 28px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        padding-left: 30px;

        ${device.less768} {
            border: 1px solid var(--color-accent);
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            padding: 0 15px;
            line-height: 12px;
            min-height: 34px;
            transition: background-color 0.3s, color 0.3s;
        }
    }
    
    & ~ ${Label}:hover {
        ${device.less768} {
            background: var(--color-border-hover);
        }
    }

    & ~ ${Label}:before {
        content: '';
        position: absolute;
        left: 0;
        top: 5px;
        width: 16px;
        height: 16px;
        border: 1px solid #252525;
        background-color: #ffffff;
        border-radius: 100%;

        ${device.less768} {
            width: 15px;
            height: 15px;
            top: 6px;
        }
    }

    & ~ ${Label}:after {
        content: '';
        position: absolute;
        -webkit-transition: all 0.2s ease;
        -moz-transition: all 0.2s ease;
        -o-transition: all 0.2s ease;
        transition: all 0.2s ease;
        left: 3px;
        top: 8px;
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background-color: var(--color-input-selected);

        ${device.less768} {
            width: 9px;
            height: 9px;
            top: 9px;
        }
    }

    &:not(:checked) ~ ${Label}:after {
        opacity: 0.0001;
    }

    &:checked ~ ${Label}:after {
        opacity: 1;
    }
`;

export const Root = styled.div`
    user-select: none;
    
    &[data-transform='button'] {
        ${device.less768} {
            width: 100%;
            
            input[type='radio'] ~ label {
                    
            }

            input[type='radio']:checked ~ label {
                ${device.less768} {
                    color: #ffffff;
                    background: var(--color-accent);
                }
            }

            input[type='radio'] ~ label:before {
                content: none;
            }

            input[type='radio'] ~ label:after {
                content: none;
            }
        }
    }
`;
